var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height pb-2"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":_vm.iFrameUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }